/**
 * アプリケーションの環境変数を管理するオブジェクト
 */
export const Environment = {
  /**
   * アプリケーションのステージを取得
   * @returns APP_STAGEの値、未設定の場合は空文字
   */
  appStage(): string {
    return process.env.REACT_APP_STAGE || '';
  },

  /**
   * アプリケーションのステージがproductionかどうかを判定
   * @returns APP_STAGEがproductionの場合はtrue
   */
  isProductionStage(): boolean {
    return this.appStage() === 'production';
  },

  /**
   * アプリケーションのステージがstagingかどうかを判定
   * @returns APP_STAGEがstagingの場合はtrue
   */
  isStagingStage(): boolean {
    return this.appStage() === 'staging';
  },

  /**
   * アプリケーションのステージがdevelopmentかどうかを判定
   * @returns APP_STAGEがdevelopmentの場合はtrue
   */
  isDevelopmentStage(): boolean {
    return this.appStage() === 'development';
  }
};
